import { useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { createFileRoute } from '@tanstack/react-router';
import ApplicationCalendar from '~/containers/ApplicationCalendar';
import ApplicationShiftDetails from '~/containers/ApplicationShiftDetails';

const ShiftDetailsWrapper = styled('div')({
  borderLeft: '1px solid var(--grey400)',
  display: 'flex',
});

export const Route = createFileRoute(
  '/application/$year/$week/$day/{-$shiftId}'
)({
  //eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const params = Route.useParams();
  return params.shiftId ? (
    <>
      {isDesktop ? <ApplicationCalendar /> : null}
      <ShiftDetailsWrapper>
        <ApplicationShiftDetails />
      </ShiftDetailsWrapper>
    </>
  ) : (
    <ApplicationCalendar />
  );
}
